import { ReactNode, useRef } from "react";
import { OverlayPanel } from "primereact/overlaypanel";
import Button, { ButtonVariant } from "../Button/Button";

import styles from "./Menu.module.css";

export const PopupMenu = ({
  children,
  variant = "secondary",
  buttonText,
  image = "dots-horizontal",
  onHide,
}: {
  children: ReactNode;
  variant?: ButtonVariant;
  buttonText?: string;
  image?: string;
  onHide?: () => void;
}) => {
  const overlayRef = useRef<OverlayPanel>(null);
  return (
    <>
      <Button
        variant={variant}
        text={buttonText}
        image={image}
        onClick={(e) => overlayRef.current?.toggle(e)}
      />
      <OverlayPanel
        className={styles.popupMenuOverlay}
        pt={{ content: { className: styles.contentPopupMenuOverlay } }}
        ref={overlayRef}
        onHide={onHide}
      >
        {children}
      </OverlayPanel>
    </>
  );
};
